import { Caption, Icon, SocialMediaPropsType, useLocales } from "@/lib/main";
import { CSSProperties } from "react";

export default function SocialMedia({
  email,
  facebook,
  instagram,
  linkedIn,
  pinterest,
  tiktok,
  x,
  youtube,

  color,
}: SocialMediaPropsType) {
  const l = useLocales();

  const ulStyle: CSSProperties = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "var(--spacing-xs)",
    listStyle: "none",
  };

  const liStyle: CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const linkStyle: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "var(--spacing-2xs)",
    padding: "var(--spacing-xs)",
  };

  return (
    <ul style={ulStyle}>
      {email ? (
        <li style={liStyle}>
          <a
            aria-label="Email"
            href={`mailto:${email}`}
            rel="noopener noreferrer"
            style={linkStyle}
            target="_blank"
            title="Email"
          >
            <Icon name="envelope-solid" color={color || "white"} size="2xl" />
            <Caption color="always-light" size="tabbar">
              {l({ ar: "البريد الإلكتروني", en: "Email" })}
            </Caption>
          </a>
        </li>
      ) : null}

      {facebook ? (
        <li style={liStyle}>
          <a
            aria-label="Facebook"
            href={facebook}
            rel="noopener noreferrer"
            style={linkStyle}
            target="_blank"
            title="Facebook"
          >
            <Icon name="facebook" color={color || "white"} size="2xl" />
            <Caption color="always-light" size="tabbar">
              {l({ ar: "فيسبوك", en: "Facebook" })}
            </Caption>
          </a>
        </li>
      ) : null}

      {instagram ? (
        <li style={liStyle}>
          <a
            aria-label="Instagram"
            href={instagram}
            rel="noopener noreferrer"
            style={linkStyle}
            target="_blank"
            title="Instagram"
          >
            <Icon name="instagram" color={color || "white"} size="2xl" />
            <Caption color="always-light" size="tabbar">
              {l({ ar: "إنستغرام", en: "Instagram" })}
            </Caption>
          </a>
        </li>
      ) : null}

      {linkedIn ? (
        <li style={liStyle}>
          <a
            aria-label="LinkedIn"
            href={linkedIn}
            rel="noopener noreferrer"
            style={linkStyle}
            target="_blank"
            title="LinkedIn"
          >
            <Icon name="linkedin" color={color || "white"} size="2xl" />
            <Caption color="always-light" size="tabbar">
              {l({ ar: "لينكدإن", en: "LinkedIn" })}
            </Caption>
          </a>
        </li>
      ) : null}

      {pinterest ? (
        <li style={liStyle}>
          <a
            aria-label="Pinterest"
            href={pinterest}
            rel="noopener noreferrer"
            style={linkStyle}
            target="_blank"
            title="Pinterest"
          >
            <Icon name="pinterest" color={color || "white"} size="2xl" />
            <Caption color="always-light" size="tabbar">
              {l({ ar: "بنترست", en: "Pinterest" })}
            </Caption>
          </a>
        </li>
      ) : null}

      {tiktok ? (
        <li style={liStyle}>
          <a
            aria-label="TikTok"
            href={tiktok}
            rel="noopener noreferrer"
            style={linkStyle}
            target="_blank"
            title="TikTok"
          >
            <Icon name="tiktok" color={color || "white"} size="2xl" />
            <Caption color="always-light" size="tabbar">
              {l({ ar: "تيك توك", en: "TikTok" })}
            </Caption>
          </a>
        </li>
      ) : null}

      {x ? (
        <li style={liStyle}>
          <a
            aria-label="X (formerly Twitter)"
            href={x}
            rel="noopener noreferrer"
            style={linkStyle}
            target="_blank"
            title="X (formerly Twitter)"
          >
            <Icon name="x" color={color || "white"} size="2xl" />
            <Caption color="always-light" size="tabbar">
              {l({ ar: "إكس", en: "X" })}
            </Caption>
          </a>
        </li>
      ) : null}

      {youtube ? (
        <li style={liStyle}>
          <a
            aria-label="YouTube"
            href={youtube}
            rel="noopener noreferrer"
            style={linkStyle}
            target="_blank"
            title="YouTube"
          >
            <Icon name="youtube" color={color || "white"} size="2xl" />
            <Caption color="always-light" size="tabbar">
              {l({ ar: "يوتيوب", en: "YouTube" })}
            </Caption>
          </a>
        </li>
      ) : null}
    </ul>
  );
}
